import { useEffect, useRef } from 'react';
import cx from 'classnames';
import { useReactDndConstructs } from '../../../../dnd/ReactDndContext';
import { getDndDesignTokens } from '../../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens } from '../../../../theme';
import cn from '../TokenDnd.css.json';
import '../TokenDnd.css';
export const useDraggableToken = props => {
  const dragRef = useRef(null);
  const {
    useDrag,
    getEmptyImage
  } = useReactDndConstructs();
  const dt = useDesignTokens();
  const dndTokens = getDndDesignTokens(dt);
  const [{
    isDragging
  }, drag, preview] = useDrag({
    type: props.type,
    item: props,
    canDrag: props.allowDrag,
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end(_draggedItem, monitor) {
      if (monitor.didDrop()) {
        props.onDidDrop?.();
      }
    }
  });
  useEffect(() => {
    preview(getEmptyImage(), {
      captureDraggingState: true
    });
  }, [preview, getEmptyImage]);
  drag(dragRef);
  return {
    ref: dragRef,
    style: dndTokens,
    className: cx(props.allowDrag && cn.draggable, isDragging && cn.draggedItem)
  };
};
//# sourceMappingURL=useDraggableToken.js.map